module.exports = __webpack_public_path__ + "static/media/hydraulicSnubbers.36b2938b.jpg";